import { render, staticRenderFns } from "./removeCard.vue?vue&type=template&id=6458001a&scoped=true&"
import script from "./removeCard.vue?vue&type=script&lang=js&"
export * from "./removeCard.vue?vue&type=script&lang=js&"
import style0 from "./removeCard.vue?vue&type=style&index=0&id=6458001a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458001a",
  null
  
)

export default component.exports